module.exports = __webpack_public_path__ + "img/05.73c09359.png";